export default "__VITE_ASSET__D6o_5yWe__"